var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "section",
      [
        _c(
          "b-card",
          { attrs: { "no-body": "" } },
          [
            _c(
              "b-card-body",
              [
                _c(
                  "b-row",
                  { staticClass: "align-items-end" },
                  [
                    _c(
                      "b-col",
                      { attrs: { lg: "2" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            staticClass: "mb-0",
                            attrs: { label: _vm.$t("Profile Type") },
                          },
                          [
                            _c(
                              "el-radio-group",
                              {
                                attrs: { size: "small" },
                                on: {
                                  change: function () {
                                    _vm.currentPage = 1
                                    _vm.reload()
                                  },
                                },
                                model: {
                                  value: _vm.profileType,
                                  callback: function ($$v) {
                                    _vm.profileType = $$v
                                  },
                                  expression: "profileType",
                                },
                              },
                              [
                                _c(
                                  "el-radio-button",
                                  { attrs: { label: "ORGANIZATION" } },
                                  [_vm._v("Company")]
                                ),
                                _c(
                                  "el-radio-button",
                                  { attrs: { label: "VENDOR" } },
                                  [_vm._v("Vendor")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.pipelineList.length > 1
                      ? _c(
                          "b-col",
                          { attrs: { lg: "2" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                staticClass: "mb-0",
                                attrs: { label: _vm.$t("Pipeline") },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      size: "small",
                                      clearable: "",
                                      placeholder: "All Pipelines",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.reload()
                                      },
                                    },
                                    model: {
                                      value: _vm.selectedPipelineId,
                                      callback: function ($$v) {
                                        _vm.selectedPipelineId = $$v
                                      },
                                      expression: "selectedPipelineId",
                                    },
                                  },
                                  _vm._l(_vm.pipelineList, function (item) {
                                    return _c("el-option", {
                                      key: item.id,
                                      attrs: {
                                        label: item.name,
                                        value: item.id,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "b-col",
                      { attrs: { lg: "2" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            staticClass: "mb-0",
                            attrs: { label: _vm.$t("Account Code") },
                          },
                          [
                            _c("el-input", {
                              attrs: { size: "small", clearable: "" },
                              nativeOn: {
                                keyup: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.reload()
                                },
                              },
                              model: {
                                value: _vm.filters.accountCode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filters, "accountCode", $$v)
                                },
                                expression: "filters.accountCode",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { lg: "2" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            staticClass: "mb-0",
                            attrs: { label: _vm.$t("Company Name") },
                          },
                          [
                            _c("el-input", {
                              attrs: { size: "small", clearable: "" },
                              nativeOn: {
                                keyup: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.reload()
                                },
                              },
                              model: {
                                value: _vm.filters.companyName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filters, "companyName", $$v)
                                },
                                expression: "filters.companyName",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { lg: "2" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            staticClass: "mb-0",
                            attrs: { label: _vm.$t("Document Type") },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  size: "small",
                                  clearable: "",
                                  placeholder: "All",
                                },
                                model: {
                                  value: _vm.filters.documentType,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filters, "documentType", $$v)
                                  },
                                  expression: "filters.documentType",
                                },
                              },
                              _vm._l(_vm.documentTypeOptions, function (item) {
                                return _c("el-option", {
                                  key: item.code,
                                  attrs: {
                                    label: item.label,
                                    value: item.label,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      {
                        staticClass:
                          "d-flex align-items-end justify-content-end",
                      },
                      [
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: _vm.showMoreFilters
                                ? "Hide more filters"
                                : "More filters",
                              placement: "top",
                            },
                          },
                          [
                            _c(
                              "el-button",
                              {
                                staticStyle: { "margin-right": "6px" },
                                attrs: {
                                  size: "small",
                                  type: _vm.showMoreFilters
                                    ? "warning"
                                    : "default",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.showMoreFilters = !_vm.showMoreFilters
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  class: _vm.showMoreFilters
                                    ? "el-icon-arrow-up"
                                    : "el-icon-arrow-down",
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.reload()
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "el-icon-search" }),
                            _vm._v(" Search "),
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            staticStyle: { "margin-left": "6px" },
                            attrs: {
                              type: "success",
                              size: "small",
                              loading: _vm.isExporting,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.exportExcel()
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "el-icon-download" }),
                            _vm._v(" Export "),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "b-row",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showMoreFilters,
                        expression: "showMoreFilters",
                      },
                    ],
                    staticClass: "mt-3",
                  },
                  [
                    _c(
                      "b-col",
                      { attrs: { lg: "4" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            staticClass: "mb-0",
                            attrs: { label: _vm.$t("Effective Date") },
                          },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                size: "small",
                                type: "daterange",
                                "range-separator": "to",
                                "start-placeholder": "From",
                                "end-placeholder": "To",
                                "value-format": "yyyy-MM-dd",
                              },
                              model: {
                                value: _vm.filters.effectiveDateRange,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.filters,
                                    "effectiveDateRange",
                                    $$v
                                  )
                                },
                                expression: "filters.effectiveDateRange",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { lg: "4" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            staticClass: "mb-0",
                            attrs: { label: _vm.$t("Expiry Date") },
                          },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                size: "small",
                                type: "daterange",
                                "range-separator": "to",
                                "start-placeholder": "From",
                                "end-placeholder": "To",
                                "value-format": "yyyy-MM-dd",
                              },
                              model: {
                                value: _vm.filters.expiryDateRange,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filters, "expiryDateRange", $$v)
                                },
                                expression: "filters.expiryDateRange",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.isLoading,
                expression: "isLoading",
              },
            ],
            staticStyle: { width: "100%" },
            attrs: {
              data: _vm.tableData,
              height: _vm.window.height - 350,
              size: "small",
            },
            on: { "sort-change": _vm.handleSortChange },
          },
          [
            _c("el-table-column", {
              attrs: {
                prop: "addTime",
                label: "Create Date",
                width: "130",
                sortable: "custom",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        " " + _vm._s(_vm.formatDate(scope.row.addTime)) + " "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { prop: "handleByUser", label: "PIC", width: "120" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        " " +
                          _vm._s(_vm.getUserName(scope.row.handleByUser)) +
                          " "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                prop: "companyName",
                label: "Client Name",
                "min-width": "150",
                sortable: "custom",
              },
            }),
            _c("el-table-column", {
              attrs: {
                prop: "accountCode",
                label: "Client Code",
                width: "100",
              },
            }),
            _c("el-table-column", {
              attrs: {
                prop: "clientCodeDoc",
                label: "Client Code(DOC)",
                width: "150",
              },
            }),
            _c("el-table-column", {
              attrs: { prop: "type", label: "Type of Doc", width: "150" },
            }),
            _c("el-table-column", {
              attrs: {
                prop: "description",
                label: "Description",
                "min-width": "150",
              },
            }),
            _c("el-table-column", {
              attrs: {
                prop: "documentNumber",
                label: "Doc Ref No",
                width: "220",
                sortable: "custom",
              },
            }),
            _c("el-table-column", {
              attrs: {
                prop: "boxFileNo",
                label: "Box File No",
                width: "100",
                sortable: "custom",
              },
            }),
            _c("el-table-column", {
              attrs: {
                prop: "dateOfIssue",
                label: "Effective Date",
                width: "140",
                sortable: "custom",
              },
            }),
            _c("el-table-column", {
              attrs: {
                prop: "dateOfExpiry",
                label: "Expiry Date",
                width: "130",
                sortable: "custom",
              },
            }),
            _c("el-table-column", {
              attrs: {
                prop: "contractTemplate",
                label: "Contract Template",
                width: "120",
              },
            }),
            _c("el-table-column", {
              attrs: { prop: "remarks", label: "Remarks", "min-width": "150" },
            }),
            _c("el-table-column", {
              attrs: {
                prop: "status",
                label: "Status",
                width: "140",
                sortable: "custom",
              },
            }),
            _vm.profileType === "ORGANIZATION"
              ? _c("el-table-column", {
                  attrs: { label: "Action Status", width: "200" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "font-size": "11px",
                                  "line-height": "1.4",
                                },
                              },
                              [
                                _c("div", [
                                  _c("b", [_vm._v("Credit:")]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        scope.row.actionCreditApproval || "-"
                                      )
                                  ),
                                ]),
                                _c("div", [
                                  _c("b", [_vm._v("BR:")]),
                                  _vm._v(
                                    " " + _vm._s(scope.row.actionBrCopy || "-")
                                  ),
                                ]),
                                _c("div", [
                                  _c("b", [_vm._v("Search:")]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        scope.row.actionCompanySearch || "-"
                                      )
                                  ),
                                ]),
                                _c("div", [
                                  _c("b", [_vm._v("Legal:")]),
                                  _vm._v(
                                    " " +
                                      _vm._s(scope.row.actionLegalReview || "-")
                                  ),
                                ]),
                              ]
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    4212672598
                  ),
                })
              : _vm._e(),
            _vm.profileType === "VENDOR"
              ? _c("el-table-column", {
                  attrs: { label: "Action Status", width: "320" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "font-size": "11px",
                                  "line-height": "1.4",
                                },
                              },
                              [
                                _c("div", [
                                  _c("b", [_vm._v("BR:")]),
                                  _vm._v(
                                    " " + _vm._s(scope.row.actionBrCopy || "-")
                                  ),
                                ]),
                                _c("div", [
                                  _c("b", [_vm._v("Search:")]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        scope.row.actionCompanySearch || "-"
                                      )
                                  ),
                                ]),
                                _c("div", [
                                  _c("b", [_vm._v("Application:")]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        scope.row.actionApplicationForm || "-"
                                      )
                                  ),
                                ]),
                                _c("div", [
                                  _c("b", [_vm._v("Declaration:")]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        scope.row.actionDeclarationForm || "-"
                                      )
                                  ),
                                ]),
                                _c("div", [
                                  _c("b", [_vm._v("Assessment:")]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        scope.row.actionAssessmentForm || "-"
                                      )
                                  ),
                                ]),
                                _c("div", [
                                  _c("b", [_vm._v("EC/SS:")]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        scope.row.actionEcOrSocialSecurity ||
                                          "-"
                                      )
                                  ),
                                ]),
                                _c("div", [
                                  _c("b", [_vm._v("Legal:")]),
                                  _vm._v(
                                    " " +
                                      _vm._s(scope.row.actionLegalReview || "-")
                                  ),
                                ]),
                                _c("div", [
                                  _c("b", [_vm._v("Price:")]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        scope.row.actionPriceComparison || "-"
                                      )
                                  ),
                                ]),
                              ]
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    2325950561
                  ),
                })
              : _vm._e(),
            _c("el-table-column", {
              attrs: {
                prop: "creditAmount",
                label:
                  _vm.profileType === "VENDOR"
                    ? "Payment Term"
                    : "Credit Limit",
                width: "100",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        " " +
                          _vm._s(
                            scope.row.creditAmount
                              ? _vm.formatNumber(scope.row.creditAmount)
                              : "-"
                          ) +
                          " "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm.profileType !== "VENDOR"
              ? _c("el-table-column", {
                  attrs: {
                    prop: "creditDay",
                    label: "Credit Day",
                    width: "100",
                  },
                })
              : _vm._e(),
            _c("el-table-column", {
              attrs: { prop: "deposit", label: "Deposit", width: "90" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        " " +
                          _vm._s(
                            scope.row.deposit
                              ? _vm.formatNumber(scope.row.deposit)
                              : "-"
                          ) +
                          " "
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass:
              "mt-2 d-flex justify-content-between align-items-center",
          },
          [
            _c("span", [
              _vm._v("Total: " + _vm._s(_vm.totalRecords) + " records"),
            ]),
            _c("el-pagination", {
              attrs: {
                "current-page": _vm.currentPage,
                "page-size": _vm.pageSize,
                layout: "prev, pager, next",
                total: _vm.totalRecords,
              },
              on: { "current-change": _vm.handlePageChange },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }